import './App.css';
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import {CrossfitLogin, Events, Athletes, Results as CrossfitResults, Ranking as CrossfitRanking, PublicRanking} from './crossfit_events/page';
import {CrossfitAuthenticatedLayout} from './crossfit_events/component';
import {UserProvider} from './crossfit_events/context';
import Results from "./comp/results";
import ScreensManagement from "./comp/screensManagement";
import Monitor from "./comp/monitor";

function App(): JSX.Element {
    return (
        <BrowserRouter>
            <UserProvider>
                <div className="App">
                    <Routes>
                        {/* Public routes */}
                        <Route path="/" element={<Navigate to="/crossfit/login" replace/>}/>
                        <Route path="/crossfit/login" element={<CrossfitLogin/>}/>
                        <Route path="/public/ranking/:eventId" element={<PublicRanking/>}/>

                        {/* CrossFit Events Protected routes with layout */}
                        <Route path="/crossfit" element={<CrossfitAuthenticatedLayout/>}>
                            <Route path="events" element={<Events/>}/>
                            <Route path="athletes" element={<Athletes/>}/>
                            <Route path="results" element={<CrossfitResults/>}/>
                            <Route path="ranking" element={<CrossfitRanking/>}/>
                        </Route>

                        {/* Legacy CrossFit routes (without layout for now) */}
                        <Route path="/results" element={<Results/>}/>
                        <Route path="/screen-management" element={<ScreensManagement/>}/>
                        <Route path="/monitor" element={<Monitor/>}/>

                        {/* Catch all - redirect to home */}
                        <Route path="*" element={<Navigate to="/" replace/>}/>
                    </Routes>
                </div>
            </UserProvider>
        </BrowserRouter>
    );
}

export default App;
